<style>
  .login {
    left: 18.8%;
    width: auto;
    position: absolute;
    bottom: 0;
  }
</style>
<div class="text-center">
  <img src="../../../assets/img/hemisphere-logo-no-tag.png" class="logo" alt="Hemisphere logo" />
</div>
<div class="inner cover">
  <form class="signup-form" [formGroup]="signinForm" autocomplete="off" (submit)="$event.preventDefault()">
    <div class="carousel-inner">
      <div formGroupName="userData" [@slideSwitcher]="currentIndex">

        <div *ngIf="currentIndex === 1" class="carousel-item active">
          <div class="text-content">
            <h2 class="signup text-left" id="professional-email">
              <span class="green-text counter">1.</span>What is your professional email address?
            </h2>
            <div class="form-group clearfix">
              <div class="input-group">
                <input id="email" aria-labelledby="professional-email" name="email" formControlName="email" type="email"
                  class="form-control" placeholder="Type here" (keydown.enter)="onEmailEnter($event)"
                  [readonly]="!inputEnabled">
                <span class="input-group-addon"
                  *ngIf="!(signinForm.get('userData.email').valid || signinForm.get('userData.email').pristine)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fill-rule="evenodd">
                      <path d="M0 0h24v24H0z" />
                      <path fill="#FF495C"
                        d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
                    </g>
                  </svg>
                </span>

              </div>
              <div class="note"><span>
                  Please check that your email address is entered correctly.
                </span></div>
              <div role="alert" class="error-container"
                *ngIf="!(signinForm.get('userData.email').valid || signinForm.get('userData.email').pristine)">
                <span class="error-message-large">This is not a valid email address</span>
              </div>
              <button type="button" id='nextEmail' (click)="checkIfExisting(signinForm.get('userData.email'))"
                class="btn btn-outline-primary btn-outline pull-left confirm {{!signinForm.get('userData.email').valid?'disabled':''}}">
                <span>Continue</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0h24v24H0z" />
                    <path fill="#FFF" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                  </g>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="currentIndex === 2" class="carousel-item active">
          <div class="text-content">
            <button class="carousel-control-prev" (click)="onBack()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="#555A69" fill-rule="evenodd" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8z" />
              </svg>
              <span>Go back</span>
            </button>
            <h2 class="signup text-left" id="enter-password">
              <span class="green-text counter">2.</span>Welcome back, please enter your password…
            </h2>
            <div class="form-group clearfix">
              <div class="input-group">
                <input aria-labelledby="enter-password" [type]="showPassword ? 'text' : 'password'" id="password"
                  formControlName="password" name="password" class="form-control" placeholder="Type here"
                  (keydown.enter)="onPasswordEnter($event)" [readonly]="!inputEnabled">
                <span class="input-group-addon"
                  *ngIf="!(signinForm.get('userData.password').valid || signinForm.get('userData.password').pristine)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fill-rule="evenodd">
                      <path d="M0 0h24v24H0z" />
                      <path fill="#FF495C"
                        d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
                    </g>
                  </svg>
                </span>
              </div>
              <div role="alert" class="error-container"
                *ngIf="!(signinForm.get('userData.password').valid || signinForm.get('userData.password').pristine)">
                <span class="helper-message">Passwords must be at least 8 characters long and include at least 1
                  uppercase letter, 1 lowercase letter, 1 number and a special character.</span>
              </div>
              <button type="button" id='nextPassword'
                (click)="signIn(signinForm.get('userData.email'), signinForm.get('userData.password'))"
                class="btn btn-outline-primary btn-outline pull-left confirm {{!signinForm.get('userData.password').valid?'disabled':''}}">
                <span>Sign in</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0h24v24H0z" />
                    <path fill="#FFF" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                  </g>
                </svg>
              </button>
              <a data-testid="signin-show-password" (click)="onShowPassword()"
                class="small login-gray-text dot-underline show-password">{{showPassword ? 'Hide' : 'Show'}}
                password</a>
              <a data-testid="signin-forgot-password" [routerLink]="['/forgot-password']" class="small login-gray-text dot-underline forgot-password">Forgot
                password?</a>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!--<span class="small login-gray-text login"><a [routerLink]="['/signin']" class="dot-underline login-gray-text">Log in</a> an exist account</span>-->
  </form>
</div>
<app-footer></app-footer>